import React from 'react'
import Navbar from "./Navbar"
import {Link} from 'react-router-dom'
import Footer from './Footer'
import img from './image/img.jpg'
import img1 from './image/img1.jpg'
import bottel1 from './image/bottle1.jpg'
import Bottel from './image/WhatsApp Image 2023-08-31 at 9.22.02 AM.jpeg'
import tin15 from './image/tin15.jpeg'
import cake from './image/cake.jpg'
import images from './image/images.jpg'
function Blogs() {
  return (
    <div><Navbar/>
    <div className="blog_container">
<div className="blog_content">
<div className="left_content">

<div className="blog_card">
<Link to="#" className="figure">
<img src={cake} className='imgss' alt="" loading="lazy"/>
<span className="tag">10 April</span>
</Link>
<section>
{/* <Link to="#" className="title">FANSO ER26500H 3.6V Li-SOCL2 Battery 9000 MAH</Link> */}
{/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat... </p> */}
</section>
</div>

<div className="blog_card">
<Link to="#" className="figure">
<img src={bottel1} className='imgss' alt="" loading="lazy"/>
<span className="tag">10 April</span>
</Link>
<section>
{/* <Link to="#" className="title">FANSO ER26500H 3.6V Li-SOCL2 Battery 9000 MAH</Link> */}
{/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat... </p> */}
</section>
</div>

<div className="blog_card">
<Link to="" className="figure">
<img src={Bottel} className='imgss' alt="" loading="lazy"/>
<span className="tag">10 April</span>
</Link>
<section>
{/* <Link to="#" className="title">FANSO ER26500H 3.6V Li-SOCL2 Battery 9000 MAH</Link> */}
{/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat... </p> */}
</section>
</div>

<div className="blog_card">
<Link to="#" className="figure">
<img src={images} className='imgss' alt="" loading="lazy"/>
<span className="tag">10 April</span>
</Link>
<section>
{/* <Link to="#" className="title">FANSO ER26500H 3.6V Li-SOCL2 Battery 9000 MAH</Link> */}
{/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat... </p> */}
</section>
</div>

<div className="blog_card">
<Link to="#" className="figure">
<img src={tin15}  className='imgss' alt="" loading="lazy"/>
<span className="tag">10 April</span>
</Link>
<section>
{/* <Link to="#" className="title">FANSO ER26500H 3.6V Li-SOCL2 Battery 9000 MAH</Link> */}
{/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat... </p> */}
</section>
</div>

<div className="blog_card">
<Link to="#" className="figure">
<img src=""  className='imgss' alt="" loading="lazy"/>
<span className="tag">10 April</span>
</Link>
<section>
{/* <Link to="#" className="title">FANSO ER26500H 3.6V Li-SOCL2 Battery 9000 MAH</Link> */}
{/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat... </p> */}
</section>
</div>

<div className="blog_card">
<Link to="#" className="figure">
<img src="" className='imgss' alt="" loading="lazy"/>
<span className="tag">10 April</span>
</Link>
<section>
{/* <Link to="#" className="title">FANSO ER26500H 3.6V Li-SOCL2 Battery 9000 MAH</Link> */}
{/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat... </p> */}
</section>
</div>

</div>
</div>

<div className="blog_content right_content">



<div className="columns books">
<span className="title">New Blog </span>
<section>
<div className="cards">
<div className="card_part card_part-one"><img src={img}  alt="blog img" style={{height:"100%"}}/></div>
<div className="card_part card_part-two"><img src={img1} alt="blog img" style={{height:"100%"}}/></div>
<div className="card_part card_part-three"  style={{backgroundImage:" url(https://img.freepik.com/free-photo/blogging-gone-viral-camera-concept_53876-127618.jpg?w=1060&t=st=1681108453~exp=1681109053~hmac=4787f8d3ee4afa3513907d69c81af50179bb999ddb56b25d952eb09ce848e527)"}}></div>
<div className="card_part card_part-four" style={{backgroundImage:" url(https://drive.google.com/file/d/1zUqK5DHu6YdHmL0UtgJe-aPTFD6085AH/view?usp=sharing)"}}></div>
</div>
</section>
</div>

<div className="columns categories">
<span className="title">Categories</span>
<section>
<Link to="#">1/2 ltr Bottle</Link> 
<Link to="#">1 ltr Bottle</Link>
<Link to="#">5 ltr Jar</Link>
<Link to="#">15 ltr Tin</Link>
<Link to="#"> 15 Kg Tin</Link>
<Link to="#">Yellow Mustard Cake</Link>
<Link to="#">Black Mustard Cake</Link>
</section>
</div>

<div className="columns posts">
<span className="title">Recent Blog </span>
<section>
{/* <Link to="#"><img src="" className='imgss' alt="" loading="lazy"/> <p>FANSO ER26500H 3.6V Li-SOCL2 Battery 9000 MAH </p></Link>
<Link to="#"><img src="" className='imgss' alt="" loading="lazy"/> <p>FANSO ER18505H 3.6V Li-SOCL2 Battery 4000 MAH</p></Link>
<Link to="#"><img src="" className='imgss' alt="" loading="lazy"/> <p>FANSO ER14250H 3.6V Li-SOCL2 Battery 1200 MAH </p></Link> */}
</section>
</div>

<div className="columns comments">
<span className="title"> Recent Comments </span>
<section>
{/* <marquee direction="up" scrollamount="4" className="marquee2">
<p>FANSO ER26500H 3.6V Li-SOCL2 Battery 9000 MAH</p> 
<p>FANSO ER14250H 3.6V Li-SOCL2 Battery 1200 MAH </p>
<p>FANSO ER18505H 3.6V Li-SOCL2 Battery 4000 MAH</p>
<p>FANSO ER18505H 3.6V Li-SOCL2 Battery 4000 MAH</p>
<p>FANSO ER18505H 3.6V Li-SOCL2 Battery 4000 MAH</p>
</marquee> */}
<div className="marquee-container">
      <div className="marquee-content">
        {/* <p>FANSO ER26500H 3.6V Li-SOCL2 Battery 9000 MAH</p>
        <p>FANSO ER14250H 3.6V Li-SOCL2 Battery 1200 MAH</p>
        <p>FANSO ER18505H 3.6V Li-SOCL2 Battery 4000 MAH</p>
        <p>FANSO ER18505H 3.6V Li-SOCL2 Battery 4000 MAH</p>
        <p>FANSO ER18505H 3.6V Li-SOCL2 Battery 4000 MAH</p> */}
      </div>
    </div>
</section>
</div>
</div>
</div>
<Footer/>
</div>
  )
}

export default Blogs